import React, { createContext, useState, useContext } from "react";

// Créez le contexte
export const LanguageContext = createContext();

// Hook personnalisé pour accéder facilement au contexte
export const useLanguage = () => useContext(LanguageContext);

// Fournisseur du contexte
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("FR"); // Langue par défaut

  const changeLanguage = (lang) => setLanguage(lang); // Fonction pour changer la langue

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

